import { FaLaptopCode, FaCloud, FaShieldAlt, FaHandshake } from 'react-icons/fa';

const Services = () => {
  return (
    <section style={styles.section}>
      <h2 style={styles.title}>Our Services</h2>
      <p style={styles.description}>
        <span style={styles.highlight}>Incogify</span>  provide a comprehensive range of IT solutions designed to evolve alongside your business. With strong industry expertise, forward-thinking strategies, and a client-centric approach, our team focuses on delivering tangible outcomes. What differentiates us is our ability to merge advanced technologies with deep technical expertise and a true commitment to supporting your business at every stage.
      </p>
      
      <div style={styles.servicesContainer}>
        <div style={styles.serviceItem}>
          <FaCloud style={styles.icon} />
          <h3 style={styles.serviceTitle}>Cloud Solutions</h3>
          <p style={styles.serviceText}>Secure and scalable cloud services for your enterprise, enabling flexibility and growth.</p>
        </div>
        
        <div style={styles.serviceItem}>
          <FaShieldAlt style={styles.icon} />
          <h3 style={styles.serviceTitle}>Cybersecurity</h3>
          <p style={styles.serviceText}>Protect your data with our advanced security solutions, ensuring compliance and peace of mind.</p>
        </div>
        <div style={styles.serviceItem}>
          <FaLaptopCode style={styles.icon} />
          <h3 style={styles.serviceTitle}>Software Development</h3>
          <p style={styles.serviceText}>Custom applications to enhance your business processes, ensuring scalability and efficiency.</p>
        </div>
        <div style={styles.serviceItem}>
          <FaHandshake style={styles.icon} />
          <h3 style={styles.serviceTitle}>IT Consulting</h3>
          <p style={styles.serviceText}>Expert guidance to optimize your IT strategy and align it with your business objectives.</p>
        </div>
      </div>
      <p style={styles.advantagesTitle}>Why Choose Us?</p>
      <ul style={styles.advantagesList}>
        <li>We deliver innovative solutions tailored to your specific business needs.</li>
        <li>Our experienced team is dedicated to providing outstanding service and dependable support.</li>
        <li>Security is at the heart of our work, protecting your data with leading practices and standards.</li>
        <li>We have a proven track record of completing projects on time while exceeding client expectations.</li>
        <li>Our solutions blend top quality with cost-effectiveness, ensuring lasting performance and value.</li>
      </ul>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '100px 20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto 40px',
    lineHeight: '1.6',
  },
  highlight: {
    color: ' #28f168',
    fontWeight: 'bold',
  },
  servicesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
  },
  serviceItem: {
    maxWidth: '300px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '3rem',
    color: ' #28f168',
    marginBottom: '15px',
  },
  serviceTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  serviceText: {
    fontSize: '1rem',
    opacity: '0.8',
  },
  advantagesTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginTop: '40px',
  },
  advantagesList: {
    fontSize: '1.2rem',
    listStyle: 'none',
    padding: '0',
    lineHeight: '1.8',
  },
};

export default Services;
